import type { FC, ReactNode } from 'react'
import { InternalShortcutContext } from './InternalShortcutContext'
import { useCreateShortcutContext } from './useCreateShortcutContext'

export interface SearchShortcutHandler {
  context: string
  onSearch: (context: string, e: KeyboardEvent) => unknown
}
export interface PrintShortcutHandler {
  context: string
  // preparePrint is called before the print dialog is shown, and can be used to prepare the print content
  // e.g. navigating to a different page or updating the content of the page
  onPreparePrint: (context: string, e: KeyboardEvent | Event) => Promise<unknown>
}

export interface CopyShortcutHandler {
  context: string
  onCopy: (context: string, e: KeyboardEvent) => unknown
}

export const internalPrintId = 'maic-internal-print'

export const ShortcutContext: FC<{ children?: ReactNode }> = ({ children }) => {
  const value = useCreateShortcutContext()
  return <InternalShortcutContext.Provider value={value}>{children}</InternalShortcutContext.Provider>
}
